export function debounce<T extends (...args: unknown[]) => void>(func: T, timeout = 250): (...args: Parameters<T>) => void {
    let timer: ReturnType<typeof setTimeout>
    return (...args: Parameters<T>) => {
        clearTimeout(timer)
        timer = setTimeout(() => {
            func.apply(this, args)
        }, timeout)
    }
}

export function isMenuMobile(): boolean {
    return window.matchMedia('(width < 1100px)').matches
}
